// Each WellPrize entry is earned per this many total reward points,
// capped at the maximum number of entries.
export const POINTS_PER_WELL_PRIZE_ENTRY = 1000;
export const MAX_WELL_PRIZE_ENTRIES = 10;

export const getWellPrizeEntries = (totalPoints?: number | null): number =>
  Math.min(
    Math.floor((Number(totalPoints) || 0) / POINTS_PER_WELL_PRIZE_ENTRY),
    MAX_WELL_PRIZE_ENTRIES
  );
